<div class="lrn-player-container">
  <div
    id="lrn-player-container"
    class="lrn-player-container standard-mcq"
    [ngClass]="playerClass"
    data-ua-id="learnosity-player"
  >
    <div id="learnosity_assess"></div>
  </div>
</div>
